var kPrefix = 'sass_'
var kTimeout = 'sass_t_'

/**
 * 获取key值
 * @param key
 */
function getItem(key) {
  var timeout = localStorage.getItem(kTimeout + key)
  if (timeout) {
    if (timeout < new Date().getTime()) {
      removeItem(key)
    }
  }
  return localStorage.getItem(kPrefix + key)
}

/**
 * 设置键值
 * @param key
 * @param value
 * @param expire [可选]过期时间(秒)
 */
function setItem(key, value, expire) {
  localStorage.setItem(kPrefix + key, value)
  if (expire) {
    setExpire(key, expire)
  }
}

/**
 * 设置key的过期时间
 * @param key
 * @param expire 过期时间(秒)
 */
function setExpire(key, expire) {
  localStorage.setItem(kTimeout + key, (new Date().getTime()) + expire * 1000)
}

/**
 * 删除key
 * @param key
 */
function removeItem(key) {
  localStorage.removeItem(kPrefix + key)
  localStorage.removeItem(kTimeout + key)
}

export default {
  getItem: getItem,
  setItem: setItem,
  setExpire: setExpire,
  removeItem: removeItem
}
